import { Component } from "@angular/core";

import { ImportTradeItemListDto, TradeItemList } from "@app/user/marks/marks-store/marks-types";
import { DefaultPopupComponent } from "@shared/overlay/default-pop-up.component";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-goods-report-popup.component.html",
	templateUrl: "./goods-report-popup.component.html.component.html",
	styleUrls: ["./goods-report-popup.component.html.component.scss"]
})
export class GoodsReportPopup extends DefaultPopupComponent {
	public report?: ImportTradeItemListDto;
	public openTradeItemList = false;
	public env = environment;

	public get tradeItemList(): TradeItemList[] {
		return this.report?.tradeItemList?.length ? this.report?.tradeItemList.filter(el => !el.successful) : [];
	}
}
